// Used in teacher-classes.component.ts, assignables-list.component.ts, side-nav.component.ts

// Angular
import { Injectable } from "@angular/core";

// RXJS/Store
import * as fromCreateStore from "#core/components/content-library/assign-cart/content-builder-store";
import * as fromCartStore from "#core/components/content-library/assign-cart/assign-cart-store";
import { Store } from "@ngrx/store";

@Injectable()
export class ClearAssignCartHelper {
    constructor(
        private createStore: Store<fromCreateStore.CreateState>,
        private cartStore: Store<fromCartStore.CartState>
    ) {}

    public clearCart() {
        this.createStore.dispatch(
            fromCreateStore.SetSelectedAssets({
                payload: { editionId: "", assets: [] },
            })
        );
        this.cartStore.dispatch(
            fromCartStore.setAssignCartTabOpen({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setAssignCartOpen({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setCreatingLesson({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setEditingLesson({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setLessonFormValidity({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setLessonFormData({ payload: null })
        );
        this.cartStore.dispatch(
            fromCartStore.setCreatingActivity({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setEditingActivity({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setActivityFormValidity({ payload: false })
        );
        this.cartStore.dispatch(
            fromCartStore.setCustomActivityFormData({ payload: null })
        );
        this.cartStore.dispatch(
            fromCartStore.setContainsComposite({ payload: false })
        );
    }
}
